import { WalletType as WalletTypeEnum } from "@/enum/component.ts";
import { sysConfigStore } from "@/stores/sysConfigStore.ts";
import { setPointType, userStore } from "@/stores/userStore";

export interface DrawerItemType {
  icon: string;
  pointName: string;
  point: string | number;
  bonus: string | number;
  pointType: number;
  isSelected?: boolean;
  onClick?: () => void;
}

export const initUserHeaderPoint = () => {
  const point_type = localStorage.getItem("AccountCurPointType");
  if (point_type && point_type != "0") {
    setPointType(Number(point_type));
  } else {
    localStorage.setItem(
      "AccountCurPointType",
      String(userStore.userInfo?.default_point_type),
    );
    setPointType(userStore.userInfo?.default_point_type || 0);
  }
};
//钱包模式
export const walletModel = (): number => {
  if (sysConfigStore.wallet_type == 3) {
    //积分钱包
    return WalletTypeEnum.point;
  } else if (sysConfigStore.wallet_type == 2) {
    return 2;
  } else if (sysConfigStore.wallet_type == 1) {
    //双钱包
    return WalletTypeEnum.bonus;
  } else {
    //单钱包
    return WalletTypeEnum.cash;
  }
};
